import MainInformation from "../MainInformation";
import ButtonMore from "../ButtonMore";
import { TechAssistance } from "../../../Shared/Components/TechAssistance";
import { PaymentsApprovementPanel } from "../../../Shared/Components/PaymentsApprovementPanel";
import {
  ModulePermission,
  userHasPermission,
} from "../../../../utils/helpers/userHelpers";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../../interfaces/users";
import { AddonsTable } from "../../../Shared/Addons/AddonsTable";
import TicketProvider from "../../../Shared/contexts/TicketContext";
import NavigationTabs from "./NavigationPages";
import { Card } from "antd";
import Link from "antd/es/typography/Link";

function TicketAssembly({ ticket, disabled, type = "assemble" }: any) {
  const { user } = useSelector((state: AuthenticationState) => state);
  return (
    <>
      <div className="z-10 w-16 pl-40 h-0 justify-center left-3/4  grid relative">
        <ButtonMore
          ticket={ticket}
          disabled={disabled}
          ticketId={ticket.id}
          currentStatus={ticket.status}
          currentPriority={ticket.priority}
          currentPriorityReason={ticket.priorityReason}
          isUnavailableForAssemble={ticket.isUnavailableForAssemble}
          assembleUnavailableStatus={ticket.assembleUnavailableStatus}
          assembleUnavailableReason={ticket.assembleUnavailableReason}
        />
      </div>
      {!!ticket?.PartsRequest.length && (
        <div className="bg-yellow-300 w-fit px-5 py-1">
          <b>Atenção:</b> Este Ticket possui solicitação de peça/assistencia
          técnica
          {!!ticket.idAssistTec && (
            <b>{` -- Cód. Assistência Técnica: ${ticket.idAssistTec}`}</b>
          )}
        </div>
      )}
      {!!ticket?.cancellationReason && (
        <div className="bg-red-500 w-fit text-white px-5 py-1">
          <b>Atenção:</b> O montador solicitou o Reagendamento/Cancelamento
          deste Ticket
        </div>
      )}
      {ticket?.priority === 1 && (
        <div className="bg-orange-500 w-fit text-white px-5 py-1">
          <b>Alta Prioridade:</b> {ticket.priorityReason}
        </div>
      )}
      {ticket?.isUnavailableForAssemble && (
        <div className="bg-red-600 w-fit text-white px-5 py-1">
          <b>Cliente indisponível para montagem:</b>{" "}
          {ticket.assembleUnavailableReason}
        </div>
      )}
      <MainInformation disabled={disabled} ticket={ticket} />
      <Card
        title="Tickets Relacionados"
        size="small"
        headStyle={{ color: " rgb(59 130 246)" }}
      >
        <div className="flex w-full">
          <div className="w-1/2">
            <h3>Ticket Pai:</h3>
            {!!ticket.parentFieldReport?.id && (
              <Link href={`/montagem?id=${ticket.parentFieldReport.id}`}>
                {ticket.parentFieldReport.title}
              </Link>
            )}
          </div>
          <div>
            <h3>Tickets Filho:</h3>
            {ticket.childFieldReports.map((item: any) => (
              <Link href={`/montagem?id=${item.id}`}>{item.title}</Link>
            ))}
          </div>
        </div>
      </Card>
      <TechAssistance originalOwner={ticket.parentFieldReport?.owner?.fullName} partsRequest={ticket.PartsRequest} />
      {(!!ticket.PaymentAdditions?.length ||
        [1, 2, 3].includes(ticket.status)) && (
        <>
          {userHasPermission(user, { payments: ModulePermission.ADMIN }) ||
          [1, 2, 3].includes(ticket.status) ? (
            <PaymentsApprovementPanel
              PaymentsAdditions={ticket.PaymentAdditions}
              ticketId={ticket.id}
              isApprovement
            />
          ) : (
            <AddonsTable
              paymentAdditions={ticket.PaymentAdditions}
              ticketId={ticket.id}
              readOnly
            />
          )}
        </>
      )}
      <TicketProvider ticket={ticket}>
        <NavigationTabs ticket={ticket} disabled={disabled} />
      </TicketProvider>
      {/* <Details disabled={disabled} ticketInfo={ticket} type="measuring" /> */}
    </>
  );
}

export default TicketAssembly;
